import MatchQuestion from './MatchQuestion';

export default MatchQuestion;